module.exports = __webpack_public_path__ + "img/Ashlar.25ef1c25.jpeg";